import { ms } from "@/ui/moderateScale";
import { Text, View } from "react-native";
import { Colors } from "@/constants/Colors";

export default function ProfilePicture({ email }: { email: string }) {
  const colorsMappers = {
    A: "rgb(170, 71, 188)",
    B: "rgb(122, 31, 162)",
    C: "rgb(120, 144, 156)",
    D: "rgb(70, 90, 101)",
    E: "rgb(236, 64, 122)",
    F: "rgb(194, 23, 91)",
    G: "rgb(92, 107, 192)",
    H: "rgb(2, 136, 209)",
    I: "rgb(0, 87, 156)",
    J: "rgb(0, 152, 166)",
    K: "rgb(0, 136, 122)",
    L: "rgb(0, 76, 63)",
    M: "rgb(104, 159, 57)",
    N: "rgb(51, 105, 30)",
    O: "rgb(140, 110, 99)",
    P: "rgb(93, 64, 56)",
    Q: "rgb(126, 87, 194)",
    R: "rgb(81, 45, 167)",
    S: "rgb(239, 108, 0)",
    T: "rgb(245, 81, 30)",
    U: "rgb(191, 54, 12)",
    V: "rgb(170, 71, 188)",
    W: "rgb(122, 31, 162)",
    X: "rgb(120, 144, 156)",
    Y: "rgb(70, 90, 101)",
    Z: "rgb(236, 64, 122)",
  };

  return (
    <View
      style={{
        width: ms(30),
        height: ms(30),
        borderRadius: ms(30),
        backgroundColor: colorsMappers[email?.charAt(0).toUpperCase()],
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Text
        style={{
          fontSize: ms(14),
          color: Colors.white,
          fontWeight: "500",
        }}
      >
        {email?.charAt(0).toUpperCase()}
      </Text>
    </View>
  );
}
